import { useEffect, useRef, useState } from 'react';
import { datadogRum } from '@datadog/browser-rum';
import { Api } from '@blink/components';
import { useSelector } from 'react-redux';

import packageJson from '../../../package.json';
import { useAuthStatus } from './useAuthStatus';

import { Store } from '@/shared/store';

export const useDataDogRum = () => {
    const isInitialized = useRef(false);
    const { isLoggedIn } = useAuthStatus();
    const [instance, setInstance] = useState<typeof datadogRum | null>(null);

    const user = useSelector((state: Store) => state.organization.info);

    useEffect(() => {
        if (isInitialized.current) {
            return;
        }

        const sessionSampleRate = Number(Api.DATADOG_SESSION_SAMPLE_RATE) || 100;
        const sessionReplaySampleRate = Number(Api.DATADOG_SESSION_REPLAY_SAMPLE_RATE) || 100;

        datadogRum.init({
            applicationId: `${Api.DATADOG_APPLICATION_ID}`,
            clientToken: `${Api.DATADOG_CLIENT_TOKEN}`,
            site: `${Api.DATADOG_SITE}`,
            sessionSampleRate,
            sessionReplaySampleRate,
            trackResources: true,
            trackLongTasks: true,
            trackUserInteractions: true,
            defaultPrivacyLevel: Api.DATADOG_PRIVACY_LEVEL,
            enablePrivacyForActionName: true,
            version: packageJson.version,
            service: 'dashboard',
        });

        isInitialized.current = true;
        setInstance(datadogRum);
    }, [isInitialized]);

    useEffect(() => {
        if (!user.email || !user.name) {
            return;
        }

        if (instance && isLoggedIn) {
            instance.setUser({
                name: user.name,
                email: user.email,
            });
        }
    }, [isLoggedIn, instance, user]);

    return instance;
};
